export const cropNormalizer = {
  cropVariations: {
    "potato": ["potato", "potatoes", "spud", "spuds"],
    "tomato": ["tomato", "tomatoes"],
    "corn": ["corn", "maize"],
    "wheat": ["wheat", "grain"],
    // Add more mappings as you discover them
  },
  
  isMatch(crop1, crop2) {
  if (!crop1 || !crop2) return false;

  const norm = s => s.toLowerCase().trim();
  const n1 = norm(crop1);
  const n2 = norm(crop2);

  for (const [, variations] of Object.entries(this.cropVariations)) {
    const set = new Set(variations.map(norm));
    const inVar1 = set.has(n1);
    const inVar2 = set.has(n2);
    if (inVar1 && inVar2) return true;
  }
   
    // Fallback: substring match
    return n1.includes(n2) || n2.includes(n1);
  }
};